import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'combineCustomersConfirmationModal.title',
    defaultMessage: 'Are you sure',
    id: 'n3zFPm',
  },
  body: {
    description: 'combineCustomersConfirmationModal.body',
    defaultMessage: 'Merging these {customersCount} customers <b>CANNOT</b> be undone. Are you sure you want to continue?',
    id: 'hGxNwk',
  },
  cancel: {
    description: 'combineCustomersConfirmationModal.cancel',
    defaultMessage: 'Cancel',
    id: 'mn+ZTK',
  },
  confirm: {
    description: 'combineCustomersConfirmationModal.confirm',
    defaultMessage: 'Confirm',
    id: 'cXPf6q',
  },
});

export default messages;
